import { render, staticRenderFns } from "./unreadmessage.vue?vue&type=template&id=1cead51c&"
import script from "./unreadmessage.vue?vue&type=script&lang=js&"
export * from "./unreadmessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports